/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPinColumns = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M2 2h18v8h-2V4h-6v11h-2V4H4v16h7v2H2V2z" fill="currentcolor" />
      <path
        d="M17.836 13.182 19 12l4 4.002-1.186 1.173-1.205-.391-2.027 2.056v2.346l-.805.814-1.68-1.682-2.39 2.39-1.414-1.415 2.39-2.39L13 17.222l.782-.8h2.4l2.036-2.02-.382-1.219z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPinColumns as PinColumns };
